import { KnownDeliveryContainerDtoType, SpaceDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Kiosk } from '../../../ui/components/pure/icons/Kiosk.icon';
import { DeliveryContainer } from './delivery-container.model';
import { PixelDimensions2D } from './pixel-dimensions-2d.model';
import { PixelPosition2D } from './pixel-position-2d.model';
import { Space as SpaceIcon } from '../../../ui/components/pure/icons/Space.icon';

export class Space extends DeliveryContainer {
  private readonly centimeterToPixelRatio = 2.6;

  constructor(space: SpaceDto) {
    super(space, KnownDeliveryContainerDtoType.Space, space.section);
  }

  public get icon() {
    return this.isKiosk ? Kiosk : SpaceIcon;
  }

  public get pixelDimensions2D() {
    return new PixelDimensions2D(
      this.outerDimensions.widthCm,
      this.outerDimensions.heightCm,
      this.centimeterToPixelRatio
    );
  }

  public get pixelPosition2D() {
    return new PixelPosition2D(this.position.x, this.position.y, this.centimeterToPixelRatio);
  }
}
